import AccordionSummary from "@mui/material/AccordionSummary";
import Accordion from "@mui/material/Accordion";
import AccordionDetails from "@mui/material/AccordionDetails";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import {Stack} from "@mui/material";

/**
 * A reusable accordion component for displaying collapsible content.
 *
 * @param {Object} props - The properties passed to the component.
 * @param {any} props.title - The title displayed in the accordion header.
 * @param {string} props.baseKey - A unique key used for identifying the accordion elements.
 * @param {React.ReactNode} props.children - The content to be displayed inside the accordion details.
 *
 * @returns {JSX.Element} The rendered accordion component.
 */
export const DamsAccordion = ({title, baseKey, children}) => {

    return (
        <Accordion
            sx={{
                minWidth: '100%', // Ensures the accordion spans the full width of its container
                boxShadow: 'none', // Removes the default shadow
                borderBottom: '1px solid #ddd', // Adds a bottom border for visual separation
            }}
            disableGutters // Removes default padding around the accordion
            key={baseKey} // Unique key for the accordion
        >
            <AccordionSummary
                id={`${baseKey}-summary`} // Unique ID for the summary section
                aria-controls="panel-content" // Accessibility attribute for associating the summary with the content
                expandIcon={<ExpandMoreIcon/>} // Icon displayed for expanding/collapsing the accordion
                sx={{
                    flexDirection: "row-reverse", // Moves the expand icon to the left
                    "& .MuiAccordionSummary-expandIconWrapper": {
                        mr: 1, // Adds spacing between the icon and the text
                    }
                }}
            >
                <Stack
                    // Aligns items in a horizontal row
                    direction="row"
                    // Unique key for the stack
                    key={`${baseKey}-heading`}
                    sx={{
                        justifyContent: "space-between",
                        alignItems: "center",
                        minWidth: '100%'
                    }}>
                    {title ? title : 'DAMS Accordion Title'} {/* Displays the title or a default placeholder */}
                </Stack>
            </AccordionSummary>

            <AccordionDetails key={`${baseKey}-details`}> {/* Container for the collapsible content */}
                {children} {/* Renders the content passed as children */}
            </AccordionDetails>
        </Accordion>
    );
};